import { render, staticRenderFns } from "./qyxxbgLookFather.vue?vue&type=template&id=011c0ab0&scoped=true&"
import script from "./qyxxbgLookFather.vue?vue&type=script&lang=js&"
export * from "./qyxxbgLookFather.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgLookFather.vue?vue&type=style&index=0&id=011c0ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c0ab0",
  null
  
)

export default component.exports